import { toast } from "react-toastify";

const requestReviewSuccessMessage = `Request for underwriting review submitted.`;
const requestSurplusReviewSuccessMessage = `Thank you! Your E&S quote request has been submitted. We appreciate your business! An Excess & Surplus representative will review this request. Please allow 24 hours for review and response.`;
const errorMessage = "Oops! Something went wrong. Please try again.";

export function showUnderwriterReviewSuccessToast() {
  showSuccessToast(requestReviewSuccessMessage);
}

export function showSurplusUnderwriterReviewSuccessToast() {
  showSuccessToast(requestSurplusReviewSuccessMessage);
}

function showSuccessToast(message: string) {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
  });
}

export function showErrorToast() {
  toast.error(errorMessage, {
    position: toast.POSITION.TOP_RIGHT,
  });
}
